"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tileSize = exports.pictogramWrapperSize = exports.pictogramSize = exports.pictogramScaleMultiplier = exports.denseTileSize = exports.densePictogramSize = void 0;
const tileSize = 106;
exports.tileSize = tileSize;
const denseTileSize = 92;
exports.denseTileSize = denseTileSize;
const pictogramSize = 48;
exports.pictogramSize = pictogramSize;
const densePictogramSize = 40;
exports.densePictogramSize = densePictogramSize;
const pictogramWrapperSize = 62;

/*
 * Multipliers used to ensure estimation of asset dimensions
 * are as close as possible to dimensions in Figma specs
 * so that overflow detection works as expected
 */
exports.pictogramWrapperSize = pictogramWrapperSize;
const pictogramScaleMultiplier = 0.8;
exports.pictogramScaleMultiplier = pictogramScaleMultiplier;